import React, { FC, useMemo } from 'react';

import SearchableSelect, {
    SearchableSelectType,
} from '../../components/inputs/searchableSelect';
import styled from 'styled-components';

import aampeTheme from '../../constants/aampeTheme';

import useMetricsInfo from '../../hooks/metrics/useMetricInfo';

import {
    METRIC_NAMES,
    TOP_PERFORMING_METRICS_DROPDOWN,
} from '../../models/metrics.model';

interface TopMetricBaseCardProps {
    selectedMetric: METRIC_NAMES;
    setSelectedMetric: (value: METRIC_NAMES) => void;
}

const TopMetricBaseCard: FC<React.PropsWithChildren<TopMetricBaseCardProps>> =
    ({ selectedMetric, setSelectedMetric, children }) => {
        const { data: metricsInfo } = useMetricsInfo();

        const options: SearchableSelectType[] = useMemo(() => {
            if (metricsInfo) {
                return TOP_PERFORMING_METRICS_DROPDOWN.map((metric) => ({
                    value: metric,
                    label: metricsInfo[metric].display_name,
                }));
            }
            return [];
        }, [metricsInfo]);

        const handleChange = (
            field: string,
            value: SearchableSelectType | SearchableSelectType[],
        ) => {
            setSelectedMetric(
                (value as SearchableSelectType).value as METRIC_NAMES,
            );
        };

        const selectedOption: SearchableSelectType | undefined = useMemo(
            () => options.find((item) => item.value === selectedMetric),
            [options, selectedMetric],
        );

        return (
            <Card className="hide-scroll-bar">
                {options && metricsInfo && (
                    <SearchableSelect
                        name={'metric_type'}
                        labelStyle={{
                            fontSize: '14px',
                            color: aampeTheme.colors.gray700,
                            fontWeight: 600,
                        }}
                        onChange={handleChange}
                        options={options}
                        value={selectedOption}
                    />
                )}
                <Body>{children}</Body>
            </Card>
        );
    };

const Body = styled.div(() => ({
    height: '100%',
}));

const Card = styled.div(() => ({
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: aampeTheme.spacing4(4),
}));

export default TopMetricBaseCard;
